'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useAuthStore } from '@/lib/stores/auth.store'

export default function Home() {
  const router = useRouter()
  const token = useAuthStore((s) => s.token)

  useEffect(() => {
    router.push(token ? '/dashboard' : '/login')
  }, [token, router])

  return null
}
